import * as React from 'react'
// import { ContentfulCodeBlock } from '../../types/graphql-types'
import Sandbox from '../../sandboxes/_internal/sandbox.component'
import { CodeBlocks } from '../../sandboxes/_internal/code-block/code-blocks.component'
import CodeBlock from '../../sandboxes/_internal/code-block/code-block.component'
import { CodeVisibilityState } from '../../sandboxes/_internal/code-toolbar/code-toolbar.component'
import { getLanguage } from '../../constants/language.constant'
import { CodeTypes } from '../../sandboxes/_internal/sandbox.types'

export type WidgetCodeBlockProps = {
  codeBlock?: GatsbyTypes.Maybe<GatsbyTypes.codeBlockFragment>
}

function trimAll(code?: string | null): string | null {
  if (!code) return null
  const trim = code.replace('```', '')
  if (trim === code) return trim
  return trimAll(trim)
}

const WidgetCodeBlock: React.FC<WidgetCodeBlockProps> = ({ codeBlock }) => {
  if (!codeBlock) return null
  const { reactCode, renderReact, hideCode, vanillaCodeTitle, vanillaCode, vanillaCodeLanguage } = codeBlock
  const react = reactCode?.reactCode ? trimAll(reactCode.reactCode) : null
  const core = vanillaCode?.vanillaCode ? trimAll(vanillaCode.vanillaCode) : null
  if (react && core && renderReact) {
    const otherCode: CodeTypes = {
      key: 'otherCode',
      title: vanillaCodeTitle || 'vanilla',
      code: core,
      language: getLanguage(vanillaCodeLanguage),
    }
    return <Sandbox renderReact={react} renderOtherCodes={otherCode} hideCode={hideCode || false} />
  }
  if (react && renderReact) {
    return <Sandbox renderReact={react} hideCode={hideCode || false} />
  }
  if (react && core && !renderReact) {
    return <CodeBlocks react={react} core={core} coreTitle={vanillaCodeTitle} />
  }
  if (react && !renderReact) {
    return <CodeBlock code={react} language="jsx" defaultCodeVisibilityState={CodeVisibilityState.LIMITED_HEIGHT} />
  }

  if (core) {
    return (
      <CodeBlock
        title={vanillaCodeTitle}
        code={core}
        language={getLanguage(vanillaCodeLanguage)}
        defaultCodeVisibilityState={CodeVisibilityState.LIMITED_HEIGHT}
      />
    )
  }

  return null
}

export default WidgetCodeBlock
